import { useRecordContext } from "react-admin";

export const OptionRenderer = () => {
  const record = useRecordContext();
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <span>{record.name}</span>
      <span>{record.code}</span>
    </div>
  );
};
export const inputText = (choice) => `${choice.name} (${choice.code})`;
export const matchSuggestion = (filter, choice) => {
  return (
    choice.code.toLowerCase().includes(filter.toLowerCase()) ||
    choice.name.toLowerCase().includes(filter.toLowerCase())
  );
};
export const filterToQuery = (searchText) => ({ all: searchText });
